import { ELabelColor, ILabel } from '../../../types/label';

interface IParams {
  labelsV1: ILabel[];
  labelsV2: ILabel[];
  extensionLabels: ILabel[];
  isUnique: boolean;
  isNewbuildingBrokerBookingEnabled?: boolean;
}

export function getNewbuildingKpnLabels({
  labelsV1,
  labelsV2,
  extensionLabels,
  isUnique,
  isNewbuildingBrokerBookingEnabled,
}: IParams) {
  const kpnLabels: ILabel[] = [];

  if (isUnique) {
    kpnLabels.push({ color: ELabelColor.Blue, text: 'Только на Циан' });
  }

  // Лейблы с бэка, пока там только выключенная Льготная ипотека.
  kpnLabels.push(...labelsV2);
  // Лейблы с бэка: https://ci-gitea.cian.tech/cianmedia/search-offers/src/commit/9afc7e76dc0bf14378e19bd84847d54bb36bde32/src/search_offers/services/search_offers_for_desktop/main.py#L413-L413
  kpnLabels.push(...labelsV1);
  // Лейблы добивок вида "Дороже на xxx руб".
  kpnLabels.push(...extensionLabels);

  if (isNewbuildingBrokerBookingEnabled) {
    kpnLabels.push({ color: ELabelColor.SimpleBlue, text: 'Онлайн-бронирование' });
  }

  return kpnLabels;
}
